export const consultantData = {
  name: "Anurag Rastogi",
  title: "FIAI, FIII",
  subtitle: "General Insurance Consultant, Actuary",
  tagline: "Senior Advisor to Deloitte, India",
  email: "anurag.rastogi@theactuary.co.in",
  yearsOfExperience: 37,
  
  hero: {
    headline: "Strategic Insurance Consulting",
    subheadline: "Leveraging 37 years of actuarial and underwriting expertise to drive growth in India's insurance sector",
    cta: "Schedule a Consultation"
  },

  about: {
    intro: "Anurag is a qualified general insurance and health insurance actuary with 360-degree experience spanning nearly 37 years, including rich experience in underwriting, claims, sales, actuarial, profit centre head, research, Merger & Acquisition, teaching, consulting and advisory services in India, Gulf & Afro Asian countries.",
    highlights: [
      "Chief Actuary & Chief Underwriting Officer with proven leadership across insurance value chain",
      "Led actuarial and underwriting workstreams in two M&A deals from due diligence to integration",
      "Senior Advisor to Deloitte, India, specializing in market entry strategies",
      "Vice President and Committee Chairperson at Institute of Actuaries of India",
      "Regular speaker at insurance seminars and conferences across markets"
    ]
  },

  experience: {
    companies: [
      "National Insurance Company Limited",
      "National Insurance Academy",
      "Bajaj General Insurance Limited (then Bajaj Allianz General Insurance Limited)",
      "HDFC ERGO General Insurance Limited"
    ],
    roles: [
      "Profit Centre Head",
      "Chief Actuary & Chief Underwriting Officer",
      "Appointed Actuary",
      "Head – Underwriting & Claims",
      "Researcher and Professor"
    ],
    committees: [
      "Insurance Regulatory & Development Authority of India (IRDAI)",
      "Indian Insurance Bureau",
      "Institute of Actuaries of India - Vice President",
      "International Actuarial Association - Education Committee Member"
    ]
  },

  qualifications: [
    "Fellow of Institute of Actuaries of India (FIAI)",
    "Fellow of Insurance Institute of India (FIII)",
    "Masters in Physics"
  ],

  services: [
    {
      id: 1,
      category: "Actuarial Services",
      icon: "calculator",
      items: [
        "Independent estimation, peer review and certification of technical liabilities of General and Health insurance companies",
        "Technical pricing of products and their certification",
        "IndAS 117 implementation, advising on policy choices, assumption setting, and compliance"
      ]
    },
    {
      id: 2,
      category: "Underwriting Services",
      icon: "shield-check",
      items: [
        "Creating strategies for taking the tariff to market using underwriting levers, distribution levers and pricing levers",
        "Aligning strategies with profit and ROC objectives of the client",
        "Market segmentation and product positioning analysis",
        "Underwriting systems identification and implementation"
      ]
    },
    {
      id: 3,
      category: "Claims Optimization",
      icon: "file-check",
      items: [
        "Claims process review and optimization",
        "Leakage analysis and prevention strategies",
        "Claims reserving and settlement strategy",
        "Claims systems identification and implementation"
      ]
    },
    {
      id: 4,
      category: "Reinsurance & Advisory",
      icon: "trending-up",
      items: [
        "Reinsurance structure optimization",
        "Investment strategies for India's general insurance sector",
        "Market entry strategies for foreign entities and PE funds",
        "M&A advisory and integration support"
      ]
    }
  ],

  testimonials: [
    {
      id: 1,
      text: "Extensive experience across the insurance value chain makes Anurag an invaluable strategic advisor.",
      author: "Insurance Industry Professional"
    }
  ]
};

export const contactFormData = {
  subjects: [
    "Actuarial Services",
    "Underwriting Strategy",
    "Claims Optimization",
    "Reinsurance Advisory",
    "Market Entry Strategy",
    "M&A Advisory",
    "General Inquiry"
  ]
};
